import { Component } from '@angular/core';

@Component({
  selector: 'tlc-churn-flow-tellent-impact-logo',
  templateUrl: './churn-flow-tellent-impact-logo.component.html',
  standalone: true,
})
export class ChurnFlowTellentImpactLogoComponent {}
